const touristAbility = (can, cannot) => {
  can('manage', 'Tourist');
};

export default touristAbility;
